module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/weather/temperature-half-668f1938c8d3ca89f8d5db80c39f7a3f.svg";